export interface CategoryItem {
  id: string;
  name: string;
  icon: string;
  count: number;
  note: string;
}

export const categories: CategoryItem[] = [
  { id: "flash", name: "圈内速报", icon: "ri-flashlight-line", count: 42, note: "短讯优先" },
  { id: "hot", name: "全网吃瓜", icon: "ri-fire-line", count: 68, note: "高热入口" },
  { id: "search", name: "热搜回声", icon: "ri-search-eye-line", count: 35, note: "按事件归" },
  { id: "star", name: "网红动态", icon: "ri-user-star-line", count: 27, note: "更新频繁" },
  { id: "show", name: "综艺八卦", icon: "ri-movie-2-line", count: 31, note: "节目向" },
  { id: "drama", name: "影视爆料", icon: "ri-clapperboard-line", count: 24, note: "剧组向" },
  { id: "emotion", name: "情感瓜田", icon: "ri-emotion-happy-line", count: 19, note: "长贴为主" },
  { id: "rare", name: "冷门合集", icon: "ri-bookmark-3-line", count: 22, note: "小众向" },
  { id: "history", name: "老瓜回顾", icon: "ri-history-line", count: 16, note: "归档向" },
  { id: "gallery", name: "图集精选", icon: "ri-image-2-line", count: 33, note: "配图为主" },
  { id: "video", name: "视频入口", icon: "ri-vidicon-line", count: 29, note: "视听向" },
  { id: "forum", name: "论坛集合", icon: "ri-chat-3-line", count: 18, note: "讨论向" },
];